import { AccountActivatedModal } from '~/components/modals/AccountActivatedModal';
import { ArchiveDepartmentModal } from '~/components/modals/archive/ArchiveDepartmentModal';
import { ArchivePatientModal } from '~/components/modals/archive/ArchivePatientModal';
import { ArchiveUserModal } from '~/components/modals/archive/ArchiveUserModal';
import { CareTeamIdInformationModal } from '~/components/modals/department/CareTeamIdInformationModal';
import { DepartmentAddedModal } from '~/components/modals/department/DepartmentAddedModal';
import { DepartmentAlertFormModal } from '~/components/modals/department/DepartmentAlertFormModal';
import { DepartmentEditDefaultAlertFormModal } from '~/components/modals/department/DepartmentEditDefaultAlertFormModal';
import { DepartmentEditDetailsFormModal } from '~/components/modals/department/DepartmentEditDetailsFormModal';
import { DepartmentFormModal } from '~/components/modals/department/DepartmentFormModal';
import { DepartmentGeneralSettingsFormModal } from '~/components/modals/department/DepartmentGeneralSettingsFormModal';
import { ExitIntentModal } from '~/components/modals/ExitIntentModal';
import { IDNAddedModal } from '~/components/modals/idn/IDNAddedModal';
import { IDNFormModal } from '~/components/modals/idn/IDNFormModal';
import { PatientAddedModal } from '~/components/modals/patient/PatientAddedModal';
import { PatientCreateModal } from '~/components/modals/patient/PatientCreateModal';
import { PatientEditAlertFormModal } from '~/components/modals/patient/PatientEditAlertFormModal';
import { PatientEditProfileFormModal } from '~/components/modals/patient/PatientEditProfileFormModal';
import { StatusInfoModal } from '~/components/modals/patient/StatusInfoModal';
import { PrivacyNoticeModal } from '~/components/modals/PrivacyNoticeModal';
import { SettingsModal } from '~/components/modals/SettingsModal';
import { TermsOfUseModal } from '~/components/modals/TermsOfUseModal';
import { AdminUserAddedModal } from '~/components/modals/user/AdminUserAddedModal';
import { AdminUserFormModal } from '~/components/modals/user/AdminUserFormModal';

export const modals = {
  Settings: SettingsModal,
  IDNForm: IDNFormModal,
  IDNAdded: IDNAddedModal,
  DepartmentForm: DepartmentFormModal,
  DepartmentEditDetailsForm: DepartmentEditDetailsFormModal,
  DepartmentEditDefaultAlertForm: DepartmentEditDefaultAlertFormModal,
  DepartmentAdded: DepartmentAddedModal,
  DepartmentGeneralSettingsForm: DepartmentGeneralSettingsFormModal,
  DepartmentAlertForm: DepartmentAlertFormModal,
  AdminUserForm: AdminUserFormModal,
  AdminUserAdded: AdminUserAddedModal,
  PatientCreate: PatientCreateModal,
  PatientEditAlertForm: PatientEditAlertFormModal,
  PatientEditProfileForm: PatientEditProfileFormModal,
  PatientAdded: PatientAddedModal,
  ExitIntent: ExitIntentModal,
  AccountActivated: AccountActivatedModal,
  TermsOfUse: TermsOfUseModal,
  PrivacyNotice: PrivacyNoticeModal,
  StatusInfo: StatusInfoModal,
  ArchiveUser: ArchiveUserModal,
  ArchiveDepartment: ArchiveDepartmentModal,
  ArchivePatient: ArchivePatientModal,
  CareTeamIdInformation: CareTeamIdInformationModal,
} as const;

export type ModalName = keyof typeof modals;
